import { RiMap2Line } from "react-icons/ri";
import { defineType } from "sanity";
import { match } from "ts-pattern";
import { multilingualBlockContentPreview } from "../base/multilingualArrayBlockContent";

const landExperienceTypes = [
  { title: "Land Programme", value: "landProgramme" },
  { title: "City Stay", value: "cityStay" }
];

export default defineType({
  name: "landExperience",
  title: "Land Experience",
  type: "document",
  icon: RiMap2Line,
  fieldsets: [
    {
      name: "details",
      title: "Land Experience Details",
      options: {
        collapsible: true,
        collapsed: true
      }
    }
  ],
  preview: {
    select: {
      title: "title",
      type: "type",
      image: "image"
    },
    prepare({ title, image, type }) {
      return {
        title: multilingualBlockContentPreview(10)(title),
        subtitle:
          landExperienceTypes.find((x) => x.value == type)?.title ||
          "Unknown type",
        media: image
      };
    }
  },
  fields: [
    {
      name: "type",
      title: "Type",
      type: "string",
      validation: (Rule) => Rule.required(),
      options: {
        list: landExperienceTypes
      }
    },
    {
      name: "title",
      title: "Title",
      type: "multilingualArrayBlockContent",
      validation: (Rule) => Rule.required(),
      options: { collapsible: false }
    },
    {
      name: "description",
      title: "Description",
      type: "multilingualArrayBlockContent",
      validation: (Rule) => Rule.required(),
      options: { collapsible: false }
    },
    {
      name: "image",
      title: "Image",
      type: "image",
      options: {
        hotspot: true
      },
      validation: (Rule) => Rule.required()
    },
    {
      name: "experienceCodes",
      title: "Experience Codes",
      type: "array",
      of: [
        {
          type: "reference",
          to: [{ type: "landProgramme" }],
          options: {
            filter: ({ document }) =>
              match(document.type)
                .with(
                  "landProgramme",
                  "cityStay",
                  () => "_type == 'landProgramme'"
                )
                .otherwise(() => "_type == ''")
          }
        }
      ]
    },
    {
      name: "enableDetailsDrawer",
      title: "Enable Details Drawer",
      type: "boolean",
      fieldset: "details",
      description:
        "If enabled adds a CTA that opens a Drawer with more details.",
      options: { collapsible: false }
    },
    {
      name: "detailTitle",
      title: "Detail Title",
      fieldset: "details",
      type: "multilingualArrayBlockContent",
      hidden: ({ parent }) => !parent?.enableDetailsDrawer,
      options: { collapsible: false }
    },
    {
      name: "detailDescription",
      title: "Detail Description",
      fieldset: "details",
      type: "multilingualArrayBlockContent",
      hidden: ({ parent }) => !parent?.enableDetailsDrawer,
      options: { collapsible: false }
    }
  ]
});
